export default __webpack_public_path__ + "static/media/puncher.01a52f32.png";